<template>
  <div>
    <div class="action-buttons">
      <el-button
        type="primary"
        :disabled="isReadOnly"
        data-qa="download-data-btn"
        :loading="downloadLoading"
        @click="downloadPlayHistory()"
        >{{ $t('Gamification_GameStepAnalytics_DownloadData') }}
      </el-button>
    </div>

    <rest-list
      :loading="isLoading"
      :payload="fetchEndpoint"
      :empty-text="$t('Gamification_GameStepAnalytics_NoData')"
      :data-handler="extractData"
    >
      <rest-list-column
        prop="account"
        :title="$t('Gamification_GamePlayHistorySubStep_CustomerId')"
        sortable
      />
      <rest-list-column
        prop="points"
        :title="$t('Gamification_GamePlayHistorySubStep_TotalPoints')"
        sortable
      />
      <rest-list-column
        prop="processed_at"
        :title="$t('Gamification_GamePlayHistorySubStep_ProcessedAt')"
        sortable
        :is-range="false"
        :filter-date-range="false"
        :filter-date="true"
        :date-picker-props="datePickerProps"
      >
        <template v-slot:default="scope">
          <p v-if="scope.row.processed_at">
            {{ castDate(scope.row.processed_at) }}
          </p>
        </template>
      </rest-list-column>
      <rest-list-column
        prop="prize.name"
        :title="$t('Gamification_GamePlayHistorySubStep_Prize')"
        :sortable="false"
        :filterable="false"
      />
      <rest-list-column
        prop="winning_prediction"
        :title="$t('Gamification_GamePlayHistorySubStep_WinningPrediction')"
        :sortable="false"
        :filterable="false"
      />
      <rest-list-column
        prop="first_entry_time"
        :title="$t('Gamification_GamePlayHistorySubStep_FirstEntryTime')"
        :is-range="false"
        :filter-date-range="false"
        :filter-date="true"
        :date-picker-props="datePickerProps"
        :sortable="false"
        :filterable="false"
      >
        <template v-slot:default="scope">
          <p v-if="scope.row.first_entry_time">
            {{ castDate(scope.row.first_entry_time) }}
          </p>
        </template>
      </rest-list-column>
    </rest-list>
  </div>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectEndpoint } from '@/core/helpers'
import { castDate, clearFiltersAndSort } from '@/modules/gamification/helpers'
import RestApi from '@/core/services/RestApi'
import { isEqual } from 'lodash'

export default {
  name: 'GamePlayHistorySubStep',
  components: {
    RestList,
    RestListColumn
  },
  props: {
    isReadOnly: {
      type: Boolean,
      required: true
    },
    gameCampaignId: {
      type: Number
    }
  },
  data() {
    return {
      isLoading: false,
      downloadLoading: false,
      fetchEndpoint: null
    }
  },
  created() {
    this.fetchEndpoint = projectEndpoint({
      method: 'get',
      url: `gamify/${this.$route.params.id}/campaign/${this.gameCampaignId}/play-history`
    })
  },
  computed: {
    datePickerProps() {
      return {
        type: 'datetime',
        value_format: 'yyyy-MM-dd HH:mm:ss',
        default_time: ['00:00:00']
      }
    }
  },
  methods: {
    castDate,
    extractData(responseData) {
      return responseData.data || []
    },
    downloadPlayHistory() {
      this.downloadLoading = true
      RestApi(
        projectEndpoint({
          method: 'post',
          url: `gamify/${this.$route.params.id}/campaign/${this.gameCampaignId}/games/download`
        })
      )
        .then(({ data }) => {
          this.$message({
            message: data.message,
            type: 'success'
          })
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.downloadLoading = false
        })
    }
  },

  beforeDestroy() {
    const newQuery = clearFiltersAndSort(this.$route.query)

    if (!isEqual(newQuery, this.$route.query)) {
      this.$router.replace({ query: newQuery })
    }
  }
}
</script>

<style scoped>
.action-buttons {
  float: right;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-campaigns/analytics/GamePlayHistorySubStep.vue